import React from 'react';
import { User, Target, Compass, Calculator } from 'lucide-react';
import { NUMEROLOGY_URL } from "../config";

export const NumerologyInsights = () => {
  const insights = [
    {
      icon: User,
      title: "Kenali Karakter Unikmu",
      description: "Temukan sifat-sifat positif dan area yang perlu dikembangkan dalam kepribadianmu.",
      accent: "accent-purple"
    },
    {
      icon: Target,
      title: "Temukan Potensi Terbaikmu", 
      description: "Gali bakat alami dan kekuatan tersembunyi yang dimilikimu sejak lahir.",
      accent: "accent-blue"
    },
    {
      icon: Compass,
      title: "Pahami Arah Kehidupanmu",
      description: "Dapatkan panduan untuk membuat keputusan penting dalam hidup dan karir.",
      accent: "accent-orange"
    }
  ];

  return (
    <section 
      className="py-20 relative"
      style={{
        background: `linear-gradient(rgba(255, 249, 242, 0.95), rgba(255, 249, 242, 0.95)), url('https://images.pexels.com/photos/6806443/pexels-photo-6806443.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="heading-1 mb-6">
            Apa itu Numerologi?
          </h2>
          
          <p className="body-large text-gray-700 mb-8">
            Numerologi adalah ilmu yang mempelajari hubungan antara angka dan nama dengan proses kehidupan manusia. 
            Melalui tanggal lahir dan nama, kita dapat mengungkap peta energi jiwa yang mempengaruhi karakter, potensi, 
            maupun hasil pengambilan keputusan dalam proses perjalanan hidup seseorang.
          </p>
          
          <div className="bg-white/80 backdrop-blur-sm border border-white/20 rounded-2xl p-8">
            <Calculator className="h-12 w-12 text-amber-600 mx-auto mb-4" />
            <h3 className="heading-2 mb-4">Bagaimana Numerologi Bekerja?</h3>
            <p className="body-medium text-gray-600">
              Setiap angka dalam tanggal lahir dan nama lahir Anda memiliki getaran energi dengan makna khusus, 
              sehingga dapat mengungkap <i>blueprint </i> unik setiap individu.
            </p>
          </div>
        </div>
        
        <div className="voice-grid max-w-5xl mx-auto">
          {insights.map((insight, index) => (
            <div key={index} className={`voice-card hover-lift ${insight.accent}`}>
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-white/50 rounded-full flex items-center justify-center mr-4">
                  <insight.icon className="h-6 w-6 text-gray-700" />
                </div>
                <h3 className="heading-3">{insight.title}</h3>
              </div>
              
              <p className="body-medium text-gray-700 mb-6">
                {insight.description}
              </p>
              
              <a href={NUMEROLOGY_URL} className="inline-flex items-center text-sm font-mono uppercase tracking-wider text-gray-800 hover:text-gray-600 transition-colors">
                <b>Pelajari Lebih Lanjut →</b>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};